"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_popper_1 = require("react-popper");

var styles_1 = require("../../styles");

var PopperContent_1 = require("./PopperContent");
/**
 * Creates a popper element when the children is hovered or focused.
 */


function PopperFocus(props) {
  var placement = props.placement,
      offset = props.offset,
      renderPopper = props.renderPopper,
      children = props.children;

  var _a = react_1.useState(false),
      isShown = _a[0],
      setShown = _a[1];

  var classes = styles_1.useStyles(function () {
    return {
      wrapper: {
        display: 'inline-block'
      }
    };
  }).classes;

  var show = function show() {
    return setShown(true);
  };

  var hide = function hide() {
    return setShown(false);
  };

  return react_1.default.createElement(react_popper_1.Manager, null, react_1.default.createElement(react_popper_1.Reference, null, function (refProps) {
    return react_1.default.createElement("div", {
      className: classes.wrapper,
      onMouseEnter: show,
      onMouseLeave: hide,
      onFocus: show,
      onBlur: hide,
      "data-show": isShown,
      ref: refProps.ref
    }, react_1.default.Children.only(children));
  }), renderPopper && react_1.default.createElement(PopperContent_1.PopperContent, {
    show: isShown,
    placement: placement,
    offset: offset
  }, renderPopper()));
}

exports.PopperFocus = PopperFocus;
PopperFocus.defaultProps = {
  placement: 'right'
};